export function isPlainObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export function createEmptyDataSheetsStore() {
  return {
    valve: {
      tab: "valve",
      totalSourceRows: 0,
      totalGroupedSheets: 0,
      items: [],
    },
    instrument: {
      tab: "instrument",
      totalSourceRows: 0,
      totalGroupedSheets: 0,
      items: [],
    },
    equipment: {
      tab: "equipment",
      totalSourceRows: 0,
      totalGroupedSheets: 0,
      items: [],
    },
  };
}

export function createEmptyPnidRevision() {
  return {
    trimListTable: [],
    bulkListTable: [],
    valveListTable: [],
    instrumentIndexTable: [],
    lineListTable: [],
    equipmentListTable: [],
    titleBlockData: {},
    dataSheetsStore: createEmptyDataSheetsStore(),
  };
}

export function normalizeDataSheetsStore(store) {
  const empty = createEmptyDataSheetsStore();

  return {
    valve: {
      ...empty.valve,
      ...(isPlainObject(store?.valve) ? store.valve : {}),
    },
    instrument: {
      ...empty.instrument,
      ...(isPlainObject(store?.instrument) ? store.instrument : {}),
    },
    equipment: {
      ...empty.equipment,
      ...(isPlainObject(store?.equipment) ? store.equipment : {}),
    },
  };
}

export function normalizePnidRevisionData(revisionData) {
  return {
    ...createEmptyPnidRevision(),
    ...(isPlainObject(revisionData) ? revisionData : {}),
    trimListTable: Array.isArray(revisionData?.trimListTable)
      ? revisionData.trimListTable
      : [],
    bulkListTable: Array.isArray(revisionData?.bulkListTable)
      ? revisionData.bulkListTable
      : [],
    valveListTable: Array.isArray(revisionData?.valveListTable)
      ? revisionData.valveListTable
      : [],
    instrumentIndexTable: Array.isArray(revisionData?.instrumentIndexTable)
      ? revisionData.instrumentIndexTable
      : [],
    lineListTable: Array.isArray(revisionData?.lineListTable)
      ? revisionData.lineListTable
      : [],
    equipmentListTable: Array.isArray(revisionData?.equipmentListTable)
      ? revisionData.equipmentListTable
      : [],
    titleBlockData: isPlainObject(revisionData?.titleBlockData)
      ? revisionData.titleBlockData
      : {},
    dataSheetsStore: normalizeDataSheetsStore(revisionData?.dataSheetsStore),
  };
}

export function buildNormalizedPnidData(data) {
  const source = isPlainObject(data?.pnidData) ? data.pnidData : {};

  const normalized = Object.fromEntries(
    Object.entries(source).map(([revisionKey, revisionValue]) => [
      String(revisionKey),
      normalizePnidRevisionData(revisionValue),
    ]),
  );

  // backward compatibility with old saved shape
  const legacyRevisionKey = String(data?.selectedPnidRevision || "0");

  const hasLegacyFlatShape =
    "trimListTable" in (data || {}) ||
    "bulkListTable" in (data || {}) ||
    "valveListTable" in (data || {}) ||
    "instrumentIndexTable" in (data || {}) ||
    "lineListTable" in (data || {}) ||
    "titleBlockData" in (data || {}) ||
    "dataSheetsStore" in (data || {});

  if (hasLegacyFlatShape) {
    normalized[legacyRevisionKey] = normalizePnidRevisionData({
      ...(normalized[legacyRevisionKey] || {}),
      trimListTable: Array.isArray(data?.trimListTable)
        ? data.trimListTable
        : normalized[legacyRevisionKey]?.trimListTable,
      bulkListTable: Array.isArray(data?.bulkListTable)
        ? data.bulkListTable
        : normalized[legacyRevisionKey]?.bulkListTable,
      valveListTable: Array.isArray(data?.valveListTable)
        ? data.valveListTable
        : normalized[legacyRevisionKey]?.valveListTable,
      instrumentIndexTable: Array.isArray(data?.instrumentIndexTable)
        ? data.instrumentIndexTable
        : normalized[legacyRevisionKey]?.instrumentIndexTable,
      lineListTable: Array.isArray(data?.lineListTable)
        ? data.lineListTable
        : normalized[legacyRevisionKey]?.lineListTable,
      titleBlockData: isPlainObject(data?.titleBlockData)
        ? data.titleBlockData
        : normalized[legacyRevisionKey]?.titleBlockData,
      dataSheetsStore: isPlainObject(data?.dataSheetsStore)
        ? data.dataSheetsStore
        : normalized[legacyRevisionKey]?.dataSheetsStore,
    });
  }

  return normalized;
}
